import { render, staticRenderFns } from "./EconWhere.vue?vue&type=template&id=4d1c45ac&scoped=true&"
import script from "./EconWhere.vue?vue&type=script&lang=js&"
export * from "./EconWhere.vue?vue&type=script&lang=js&"
import style0 from "./EconWhere.vue?vue&type=style&index=0&id=4d1c45ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d1c45ac",
  null
  
)

export default component.exports